module.exports = __webpack_public_path__ + "static/img/shengxiang-b.c412f75.png";


//////////////////
// WEBPACK FOOTER
// ./static/compress-img/public/customer/shengxiang-b.png
// module id = yuu+
// module chunks = 1